import React, { useMemo } from "react";
import { HelpOutline } from "@mui/icons-material";
import { CLASSES } from "../../core/characterUtils";
import DropdownMenu from '../utils/DropdownMenu';
import "./CharacterSelector.css";

const CLASS_TOOLTIP = { fr: "Classe", en: "Class", de: "Klasse", es: "Clase", pt: "Classe" };
// Announced for late 2026, not playable yet: listed last, greyed out, kept out
// of CLASSES so nothing that iterates the real classes sees it. Names from
// Ankama’s announcement (dofus.com fr/en/pt, wakfu.com es; no German edition).
const UPCOMING_CLASS_LABEL = { fr: "Bellaphone", en: "Bellaphone", de: "Bellaphone", es: "Belíade", pt: "Beléfone" };

const CharacterSelector = ({ build, setBuild, lang = 'fr', disabled = false }) => {
    // Derive characterClass directly from build so it updates when build changes
    const characterClass = useMemo(() => build?.getCharacterClass(), [build]);

    // Handle class change: update build's character class
    const handleClassChange = (newClass) => {
        if (!build || disabled) return;
        const newBuild = build.setCharacterClass(newClass);
        setBuild(newBuild);
    };

    const dropdownItems = CLASSES.map(cls => ({
        label: cls.label[lang],
        icon: <img src={cls.icon} alt={cls.label[lang]} />,
        onClick: () => handleClassChange(cls),
    }));
    dropdownItems.push({
        label: UPCOMING_CLASS_LABEL[lang] || UPCOMING_CLASS_LABEL.en,
        icon: <HelpOutline />,
        disabled: true,
    });

    const activeIndex = useMemo(() => {
        if (!characterClass) return 0;
        return CLASSES.findIndex(cls => cls.name === characterClass.name);
    }, [characterClass]);

    return (
        <div className="character-selector">
            {/* <div className="cover-wrapper" style={{ backgroundImage: `url(${selected.cover})` }}>
                <img className="cover" src={selected.cover} alt={selected.label_fr} />
            </div> */}
            <div className="character-info">
                <DropdownMenu
                    items={dropdownItems}
                    activeIndex={activeIndex === -1 ? 0 : activeIndex}
                    dropdownClassName=""
                    menuClassName="character-selector-menu"
                    buttonTooltip={CLASS_TOOLTIP[lang] || CLASS_TOOLTIP.en}
                    disabled={disabled}
                />
            </div>
            {/* <img className="portrait" src={selected.portrait} alt={selected.label_fr} /> */}
        </div>
    );
};

export default CharacterSelector; 
